import { jwtDecode, JwtPayload } from "jwt-decode";

export const VerifyToken = (token: string) => {
  return jwtDecode(token);
};

/** Decodes JWT; returns null if malformed or past `exp` (when `exp` is present). */
export function decodeAccessTokenIfValid(token: string): JwtPayload | null {
  try {
    const decoded = jwtDecode<JwtPayload>(token);
    if (typeof decoded.exp === "number") {
      const nowSec = Math.floor(Date.now() / 1000);
      if (nowSec >= decoded.exp) return null;
    }
    return decoded;
  } catch {
    return null;
  }
}
